import {errorResponse} from "./errorResponse";
import 'whatwg-fetch'
import * as system from "../constants/systemConstants";

export const axiosWrap = function(method, url, data = null, options = {}) {
    // Add timestamp to all requests
    const timestamp = new Date().toISOString();

    let config = {
        method: method,
        headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "X-Request-Timestamp": timestamp, // Add timestamp to headers
        },
        ...options
    };

    // Add timestamp to request body for supported methods
    let requestData = data;
    if (['POST', 'PUT', 'PATCH'].includes(method.toUpperCase())) {
        if (data) {
            if (typeof data === 'string' || data instanceof String) {
                try {
                    const parsedData = JSON.parse(data);
                    requestData = JSON.stringify({ ...parsedData, requestTimestamp: timestamp });
                } catch (e) {
                    // If not valid JSON, just use original data
                    requestData = data;
                }
            } else if (typeof data === 'object') {
                requestData = { ...data, requestTimestamp: timestamp };
            }
        } else {
            requestData = { requestTimestamp: timestamp };
        }
    }

    if (requestData) {
        if (typeof requestData === 'string' || requestData instanceof String) {
            config.body = requestData;
        }
        else {
            config.body = JSON.stringify(requestData);
        }
    }

    return new Promise( (resolve, reject) => {
        let currURL =  new URL(window.location.href);
        let parsedURL = currURL.pathname.split("/");
        let refKey = parsedURL[2];
        const authorizationToken = localStorage.getItem(`${system.STORAGE_TOKEN}_${refKey}`);

        if (authorizationToken) {
            config.headers["Authorization"] = "Bearer " + authorizationToken;
        }

        try {
            fetch(url, config).then(res => {
                console.log("Fetch Success.");

                // console.log("res:", res);
                if (res.status === 200) {

                    res.json().then(body => {
                        resolve(body);
                    });

                }
                else {
                    if (res.status < 400)
                    {
                        resolve({status: res.status});
                    } else if (res.status === 401) {
                        errorResponse(res);
                        // console.log("res:", res);
                    } else {
                        console.log("Failure mid");
                        console.log(res.status);
                        errorResponse({status: res.status});
                        //reject("Request failed:", url);
                    }
                }

            }, error => {
                console.log("Failure lower mid");
                console.log(error);
                errorResponse(error); //TODO this needs to get the body of the error, this doesn't currently get called
                reject("Request failed:", url);
            });
        } catch (error) {
            console.log("Failure");
            console.log(error);
            errorResponse(error); //TODO this needs to get the body of the error, this doesn't currently get called
            reject("Request failed:", url);
        }
    });
};

export const GET = "get";
export const PUT = "put";
export const POST = "POST";
